function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M9.93483 2.96582C11.4506 2.96582 12.6843 4.23964 12.6843 5.80526L12.6843 8.91734C12.6843 10.4791 11.4537 11.7498 9.94101 11.7498L3.06664 11.7498C1.55027 11.7498 0.315906 10.4766 0.315906 8.91096L0.315906 5.79887C0.315906 4.23709 1.54718 2.96582 3.06046 2.96582H3.64177L9.93483 2.96582Z",
  fill: "#2EAE65"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.8379 8.37181L8.63689 6.53639C8.82241 6.3467 8.82241 6.04142 8.63565 5.85235C8.44889 5.66391 8.14772 5.66454 7.96219 5.85361L6.97705 6.85863L6.97705 0.483665C6.97705 0.216707 6.76369 0 6.50024 0C6.23741 0 6.02468 0.216707 6.02468 0.483665L6.02468 6.85863L5.03891 5.85361C4.85339 5.66454 4.55222 5.66391 4.36545 5.85235C4.27207 5.9472 4.22507 6.07094 4.22507 6.19532C4.22507 6.31843 4.27207 6.44217 4.36422 6.53639L6.1632 8.37181C6.25288 8.46289 6.37409 8.5144 6.50024 8.5144C6.62702 8.5144 6.74823 8.46289 6.8379 8.37181Z",
  fill: "#2EAE65"
});

function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ceb54360.svg";
export { ForwardRef as ReactComponent };